import React from 'react';

import { TripAssistSettings } from '../../types/tripGroup';
import { StyledSwitch } from '../../components/forms/Switch';

interface SwitchSettingsProps {
  name: string;
  helperText?: string;
}

interface TripAssistSettingsProps {
  tripAssistSettings: TripAssistSettings;
  setTripAssistSettings: (
    settings:
      | TripAssistSettings
      | ((settings: TripAssistSettings) => TripAssistSettings),
  ) => void;
  isOverridden: boolean;
}

export const TripAssistSection: React.FC<TripAssistSettingsProps> = ({
  tripAssistSettings,
  setTripAssistSettings,
  isOverridden,
}) => {
  const assignSetting = (field: string, value: boolean) => {
    setTripAssistSettings(settings => {
      return { ...settings, [field]: value };
    });
  };

  const SwitchSetting: React.FC<SwitchSettingsProps> = ({
    name,
    helperText,
  }) => (
    <StyledSwitch
      text={name}
      helperText={helperText}
      isDisabled={!isOverridden}
      on={!!tripAssistSettings[name as keyof TripAssistSettings]}
      onChange={(val: boolean) => {
        assignSetting(name, val);
      }}
    />
  );

  return (
    <>
      <h4>Trip Assist</h4>
      <SwitchSetting
        name="createIssues"
        helperText="Enable the creation of issues"
      />
      <SwitchSetting
        name="createInvalidTripIssues"
        helperText="Enable the creation of Invalid Itinerary issues when a trip is not monitorable"
      />
      <SwitchSetting
        name="requireOptedInTravelerProfilesForIssueCreation"
        helperText="Only create issues when at least one of the travelers on a trip has opted for Traveler Trip Alerts"
      />
    </>
  );
};
